import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { JobListTemplate } from "./JobListTemplate";

const BAR_AREAS: [string, number | string][] = [
  ["job", "70%"],
  ["subject", "60%"],
  ["trigger", 60],
  ["status", 60],
  ["started", "60%"],
  ["duration", 40],
  ["summary", "50%"],
];

/** A placeholder job row shown while the list loads, on the same grid as JobListRow. */
export const JobListSkeletonRow = () => {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <JobListTemplate
        sx={{
          py: 1,
        }}
      >
        {BAR_AREAS.map(([area, width]) => (
          <Skeleton
            height={24}
            key={area}
            sx={{ gridArea: area }}
            width={width}
          />
        ))}
      </JobListTemplate>
    </Box>
  );
};
